import { useRouter } from 'next/router';
import Expander from 'components/shared/expander/expander';
import SiteLink from 'components/shared/sitelink';
import { addLocaleToHref } from 'lib/utils/helpers';
import { FAQ_HUB_SLUG } from 'lib/contentful/fragments/faq';
import { getReadMoreLabel } from 'components/pages/faq/breadcrumbs';
import styles from './faqAccordion.module.scss';

// Renders a list of pageFaqQuestion entries as Expander accordion items.
// Opening an item shows a short preview of the answer (derived at parse time
// from the question's `answer` rich text) followed by a "read more" link to
// the question's dedicated page. Questions without an answer yet fall back to
// just the link. Standalone — does not modify the existing Expander component
// or affect accordion usage elsewhere on the site.
const FaqAccordion = ({ data, locale }) => {
  const router = useRouter();

  if (!data?.questions?.length) return null;

  const readMoreLabel = getReadMoreLabel(null, locale);
  // Use the hub the accordion is actually rendered under (Product FAQ,
  // Customer Service, etc.) so "read more" stays within the current hub.
  // Falls back to the default hub slug when no hub context is threaded in.
  const hubUrlSlug = data?.hubUrlSlug || FAQ_HUB_SLUG;

  return (
    <section id={data.anchorId} className={styles.section}>
      {data.title && <h2 className={styles.title}>{data.title}</h2>}
      <ul className={styles.list}>
        {data.questions.map(question => {
          const url = `/${hubUrlSlug}/${question.categorySlug}/${question.slug}`;
          const href = addLocaleToHref(url, locale, router);
          return (
            <li key={question.id} className={styles.item}>
              <Expander
                title={question.question}
                className={styles.expander}
                titleClassName={styles.expanderTitle}
              >
                <p className={styles.preview}>
                  {question.answerPreview && <>{question.answerPreview} </>}
                  <SiteLink
                    locale={locale}
                    href={href}
                    className={styles.readMore}
                    aria-label={question.question}
                  >
                    {readMoreLabel}
                  </SiteLink>
                </p>
              </Expander>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default FaqAccordion;
